import type { RouteRecordRaw } from 'vue-router';
import SchoolLoginPage from './pages/SchoolLoginPage/SchoolLoginPage.vue';
import SchoolDashboardPage from './pages/SchoolDashboardPage/SchoolDashboardPage.vue';
import SchoolTeacherHomePage from './pages/SchoolTeacherHomePage/SchoolTeacherHomePage.vue';
import SchoolClassDetailPage from './pages/SchoolClassDetailPage/SchoolClassDetailPage.vue';
import SchoolJoinPage from './pages/SchoolJoinPage/SchoolJoinPage.vue';
import SchoolForgotPasswordPage from './pages/SchoolForgotPasswordPage/SchoolForgotPasswordPage.vue';
import SchoolResetPasswordPage from './pages/SchoolResetPasswordPage/SchoolResetPasswordPage.vue';

export const base: RouteRecordRaw[] = [
  {
    name: 'school.login',
    path: 'school/login',
    component: SchoolLoginPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'school.register',
    path: 'school/register',
    component: SchoolLoginPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'school.password.forgot',
    path: 'school/password/forgot',
    component: SchoolForgotPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    // Target of the link in the reset email; the backend builds this URL for the
    // school flow (see RESET_PASSWORD_URL_SCHOOL). The token arrives as ?code=.
    name: 'school.password.reset',
    path: 'school/password/reset',
    component: SchoolResetPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    // Enrollment invite link target. NON-/school path on purpose: the school guard bounces
    // unauthenticated /school/* to login (losing the class id); this page stashes it first.
    name: 'school.class.join',
    path: 'class-join',
    component: SchoolJoinPage,
    meta: {
      requiresAuth: false,
    },
  },
];

export const main: RouteRecordRaw[] = [];

export const school: RouteRecordRaw[] = [
  {
    name: 'school.home',
    path: '',
    redirect: { name: 'school.dashboard' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'school.dashboard',
    path: 'dashboard',
    component: SchoolDashboardPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'DASHBOARD',
      schoolRoles: ['school_admin'],
    },
  },
  {
    name: 'school.teacher.home',
    path: 'teacher/home',
    component: SchoolTeacherHomePage,
    meta: {
      requiresAuth: true,
      headerTitle: 'MY_CLASSES',
      schoolRoles: ['teacher'],
    },
  },
  {
    name: 'school.class.detail',
    path: 'classes/:documentId',
    component: SchoolClassDetailPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'CLASS',
      // Class pages (list + detail) are teacher/admin-only; students have no access.
      schoolRoles: ['school_admin', 'teacher'],
    },
  },
];
